export default "__VITE_ASSET__pNv4xYlm__"